import { Helmet } from 'react-helmet';

export default function MetaHeader() {
  return (
    <Helmet defaultTitle="DDB" titleTemplate="DDB | %s">
      <link rel="canonical" href={import.meta.env.VITE_APP_URL} />
    </Helmet>
  );
}
